import React from 'react';
import Hero from '../Components/Hero/Hero';
import FloatingActions from '../Components/FloatingActions/FloatingActions';
import About from '../Components/About/About';
import Services from '../Components/Services/Services';
import SpecialPackages from '../Components/SpecialPackages/SpecialPackages';
// import TourPackages from '../Components/TourPackages/TourPackages';
import GallerySection from '../Components/GallerySection/GallerySection';
// import SummerSpecial from '../Components/SummerSpecial/SummerSpecial';
import Testimonials from '../Components/Testimonials/Testimonials';





const Home = () => {
  return (
    <>
      <Hero />
      <FloatingActions />
      <About />
      <Services />
      <SpecialPackages/>
      {/* <TourPackages /> */}
      <GallerySection />
      {/* <SummerSpecial /> */}
      <Testimonials />
     

      
      
     
      
    </>
  );
};

export default Home;
